export default __webpack_public_path__ + "static/media/2D_Barcode_Logo_EN.f7c452f2.svg";